import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
 import { HourTypeGroupService } from '../proxy/general/controllers/hour-type-group.service';
 import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';
 import { HourTypeService } from '../proxy/general/controllers/hour-type.service';

FieldBuilder.setNamespace('General');

export const HOURTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.HourType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.HourType.Code')
    .required()
    .minLength(1)
    .maxLength(4)
    .build(),
  FieldBuilder
    .time('startHour', 'Entity.HourType.StartHour')
    .required()
    .build(),
  FieldBuilder
    .time('endHour', 'Entity.HourType.EndHour')
    .required()
    .build(),
  FieldBuilder
    .number('coefficient', 'Entity.HourType.Coefficient')
    .required()
    .decimal(2,5)
    .build(),
  FieldBuilder
    .checkbox('isVisibleInMobile', 'Entity.HourType.IsVisibleInMobile')
    .build(),
  FieldBuilder
    .text('condition', 'Entity.HourType.Condition')
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('hourTypeGroupId', 'Entity.HourTypeGroup', HourTypeGroupService)
    .required()
    .displayFromNested('hourTypeGroup.name')
    .sortBy('hourTypeGroup.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('equivalentHourId', 'Entity.HourType.EquivalentHour', HourTypeService)
    .required()
    .displayFromNested('equivalentHour.name')
    .sortBy('equivalentHour.name')
    .build(),
];

export const HOURTYPE_CONFIG = {
  entityName: 'HourType',
  localizationKey: 'General::Entity.HourType',
  fields: HOURTYPE_FIELDS,
  permission: 'ControllingCalendar.HourTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
